import { render, staticRenderFns } from "./ManuscriptPreview.vue?vue&type=template&id=a0516ab2&scoped=true&"
import script from "./ManuscriptPreview.vue?vue&type=script&lang=ts&"
export * from "./ManuscriptPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ManuscriptPreview.vue?vue&type=style&index=0&id=a0516ab2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0516ab2",
  null
  
)

export default component.exports